/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：登录页面
 * 更新记录:
 */
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SwJwtService } from '../librarys/serves/sw-jwt.service';
import { SwRouteguardService } from '../librarys/serves/sw-routeguard.service';
import { SwMenuService } from '../librarys/serves/sw-menu.service';
import { environment } from 'src/environments/environment';
import { SwLoadingmaskComponent } from '../librarys/components/basic-components/sw-loadingmask/sw-loadingmask.component';
import { Md5 } from "ts-md5";
import { SwHttpClientService } from '../librarys/serves/sw-http-client.service';
import { ConfigurationService } from '../librarys/serves/public/configuration.service';
import { OninitService } from '../librarys/serves/oninit.service';
import { SwMassageBoxService } from '../librarys/serves/sw-massage-box.service';
import { SwLoadingmaskService } from '../librarys/components/basic-components/sw-loadingmask/sw-loadingmask.service';
import { TranslateService } from '@ngx-translate/core';
import { SystemIdService } from '../librarys/serves/public/system-id.service';
import { LoginWebSocketService } from './login-web-socket.service';
import * as CryptoJS from 'crypto-js';
import { TextEncoder } from 'text-encoding';

declare var $: any;
declare const QRCode: any;
@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginWebSocketService]
})
export class LoginComponent implements OnInit, AfterViewInit {
  msg: string = "";
  isJwtLoginMode: boolean = false;
  loginSystem: string = "";
  loginImage: string = ''
  projectLogo: string = "";
  projectLogoWidth: string = "";
  copyRight: string = '';//版权信息
  systemData: any = [];
  partnerData: any = [];
  loginStyle = environment.loginStyle;
  multiTenancy: boolean; //是否开启多租户管理模式
  closeEye: boolean = true;
  enableSsoLogin: boolean = environment.enableSsoLogin; //是否启用sso登录

  defualtlanguage: string = 'zh-CN';//默认语言
  languages: any = [{ id: 'zh-CN', text: '中文简体' }, { id: 'en-US', text: 'English' }] //所有语言
  isLanguage: boolean = false; //是否使用切换语言
  isVcode: boolean = true; //是否有验证码功能
  isSlideVerify: boolean = false; //滑动验证码是否通过；默认为false，未通过；true通过
  isSliderCode: boolean = false; //登录界面是否有滑动验证功能,默认不需要滑动验证,值为false
  isCA = false; // 是否开启CA登陆
  paramLogin = {};//登录参数

  loginTypeEx: number = 1;  //登录方式扩展：默认密码登录

  constructor(
    private _http: SwHttpClientService,
    private init: OninitService,
    private jwt: SwJwtService,
    private config: ConfigurationService, //初始化配置文件
    private swMenus: SwMenuService,
    private box: SwMassageBoxService,  //消息提示服务
    private swRouter: SwRouteguardService,
    private systemId: SystemIdService,
    private swLoadingmaskService: SwLoadingmaskService,  //过渡效果
    public translateService: TranslateService,
    private websocketService: LoginWebSocketService
  ) {
    this.defualtlanguage = environment.defaultLanguage
    if (environment.defaultLanguage) {
      this.isLanguage = true;
    }
    this.isSliderCode = environment.isSliderCode
    this.isCA = environment.isCA;
  }

  LoginModel: any = {
    loginName: '',
    systemCode: '',
    loginPassword: '',
    vcode: '',
    partnerCode: '',
    openUserId: ''
  };
  @ViewChild("loading") loading: SwLoadingmaskComponent;
  ngOnInit() {
    //如果是soo登录，执行以下步骤
    if (environment.enableSsoLogin) {
      let systemId = this.systemId.getSystemId();
      let code = this.getQueryVariable("code");
      if (code) {
        //存在则先请求一次带code的请求头，拿到token
        let headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'code': code
        }
        this._http.Post(environment.seekerWebAPI + "sw/init?systemId=" + systemId, {}, headers).subscribe(data => {

        });
      } else {
        //不存在说明没有进行过sso登陆
        this._http.Post(environment.seekerWebAPI + "sw/init?systemId=" + systemId, {}).subscribe(data => {

        });
      }
      return false;
    }

    this.multiTenancy = environment.multiTenancy
    if (this.translateService.currentLang) {
      this.defualtlanguage = this.translateService.currentLang;
    }
    this.initValue();
    if (this.tryLoginByFocusCode()) {
      return;
    }
    this.LoginModel.openUserId = this.getQueryVariable("openUserId") || '';
    this.location()
    this.getimg();

  }
  ngAfterViewInit(): void {
    //初始化滑动模块验证功能
    this.initSlideVerify()
  }
  getQueryVariable(variable) {
    try {
      var query = window.location.hash.split("?")[1];
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
      }
      return (false);
    } catch {
      return (false);
    }
  }

  /**
   * 单点登录：URL仅携带一次性授权码focusOpenCode，由后端校验授权码后经响应体返回jwt
   * 安全修复：不再无条件信任URL中的jwt令牌，jwt不出现在URL中
   */
  tryLoginByFocusCode() {
    const focusOpenCode = this.getQueryVariable("focusOpenCode");
    if (!focusOpenCode) {
      return false;
    }
    this.isJwtLoginMode = true; //进入登录中状态，隐藏登录表单
    this.removeUrlParam("focusOpenCode"); //立即从地址栏剥离一次性授权码
    this._http.Post(environment.seekerWebAPI + "sw/focusCodeLogin", { focusOpenCode: focusOpenCode }).subscribe(data => {
      if (data && data["code"] == 200 && data["data"] && data["data"]["jwt"]) {
        //服务端已校验授权码并签发令牌，此时才写入本地存储并初始化工作台
        this.finishLogin(data["data"], false);
      } else if (data && data["code"] == 200 && data["data"] && data["data"]["openUserId"]) {
        //账号未绑定，回到登录页进入账号绑定流程
        this.LoginModel.openUserId = data["data"]["openUserId"];
        this.backToLoginForm("当前账号未绑定系统用户，请输入账号密码完成绑定");
      } else {
        this.backToLoginForm((data && data["msg"]) || "单点登录失败，请重新进入");
      }
    });
    return true;
  }

  //单点登录未完成，恢复登录表单并提示（表单初次未展示，需补初始化验证码）
  backToLoginForm(msg: string) {
    this.isJwtLoginMode = false;
    this.msg = msg;
    setTimeout(() => {
      this.getimg();
      this.initSlideVerify();
    }, 100);
  }

  //从地址栏剥离指定hash参数，避免授权码残留在浏览器历史、书签与分享链接中
  removeUrlParam(name: string) {
    try {
      const hash = window.location.hash;
      const idx = hash.indexOf("?");
      if (idx > -1) {
        const params = hash.substring(idx + 1).split("&").filter(p => p.split("=")[0] != name);
        const newHash = hash.substring(0, idx) + (params.length > 0 ? "?" + params.join("&") : "");
        window.history.replaceState(null, "", window.location.pathname + window.location.search + newHash);
      }
    } catch { }
  }

  finishLogin(data, isVid) {
    if (this.LoginModel.partnerCode) {
      window.open("http://www.baidu.com", "_self")
      return;
    }

    this.init.GC(); // 清除缓存，工作台和路由复用
    this.jwt.setToKen("language", this.defualtlanguage); //登录成功后将当前语言设置存进缓存
    this.jwt.setToKen("token", data["jwt"]); //添加新的token
    this.jwt.removeItem("TabMenu"); //添加新的工作台
    this.jwt.setToKen("systemId", data["systemId"]);
    if (data["isDefaultPwd"]) {
      this.jwt.setToKen("isDefaultPwd", data["isDefaultPwd"]);
    } else {
      this.jwt.removeItem("isDefaultPwd");
    }

    this.swMenus.location('login');
    if (data["expire"]) {
      this.box.danger(data["expire"]);
    }
    this.swMenus.valueUpdated.subscribe(val => {
      if (!val) {  //菜单获取失败,还在登陆页面,就要更新验证码
        if (isVid) {
          this.getimg();
        }
      }
    })
  }

  /**
 * 切换登录方式
 */
  changeLoginType(type: number) {
    this.loginTypeEx = type;
    if (type == 1) {
      setTimeout(() => {
        this.initSlideVerify();
      }, 100);
    }
  }

  //
  //滑动验证初始化
  initSlideVerify() {
    let that = this
    this.isSlideVerify = false
    $('#mpanel1').empty();
    $('#mpanel1').slideVerify({
      type: 1,		//类型
      vOffset: 3,	//误差量
      barSize: {
        width: '100%',
        height: '38px',
      },
      language: this.defualtlanguage,
      ready: function () {
      },
      success: () => {
        that.isSlideVerify = true
      },
      error: function () {
      }

    });
  }
  //密码切换眼睛功能
  clickEye() {
    this.closeEye = !this.closeEye;
  }
  enterKeyword(event) {
    let str = event.target.value
    //包含大小写字母、数字和特殊字符，至少8位
    var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[1-9])(?=.*[\W]).{8,}$/
  }

  //AES加密：安全修复，密钥改用一次性图形验证码vid（32位UUID即256位密钥），不再使用前端硬编码固定密钥
  AESEncryptData(pwd, key) {
    if (!key) {
      return pwd; // 缺少密钥标识时不做可逆加密，由服务端拒绝本次登录
    }
    pwd = pwd.toString().toLocaleUpperCase();
    const encoder = new TextEncoder();
    const gb2312Bytes = encoder.encode(pwd);

    // 将字节数组转换为WordArray
    const gb2312Data = CryptoJS.lib.WordArray.create(gb2312Bytes);

    // 执行AES加密，使用ECB模式和PKCS7填充
    const pwdvid = CryptoJS.AES.encrypt(gb2312Data, CryptoJS.enc.Utf8.parse(key), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
    return pwdvid;
  }

  //发送验证码
  sendCode() {
    if (!this.LoginModel.phone) {
      this.box.danger("请输入手机号码");
      return;
    }
    // 安全修复：手机号经POST请求体传输，不再拼接URL查询串；
    // 后端存在性掩蔽，统一返回受理成功，由发码环节在服务端内部判断存在性
    let url = environment.seekerWebAPI + "sw/checkUserByPhone";
    this._http.Post(url, { phone: this.LoginModel.phone }).subscribe(res => {
      if (res["code"] == 200) {
        this.startCountdown();
        let urlCode = environment.saasWebAPI + "saas/querySmsVCode";
        this._http.Post(urlCode, { phone: this.LoginModel.phone }).subscribe(resCode => {
          if (resCode["code"] == 200) {
            this.box.success(resCode["data"]);
          } else {
            this.box.danger(resCode["msg"])
          }
        })
      } else {
        this.box.danger(res["msg"])
      }
    })
  }

  //登录
  smsLogin({ value, valid }, event: Event) {
    if (valid) {
      // 安全修复：手机号与验证码经POST请求体传输，不再拼接URL查询串
      let url = environment.seekerWebAPI + "sw/zzSmsLogin";
      let body: any = { phone: this.LoginModel.phone, svCode: this.LoginModel.svCode };
      if (this.LoginModel.openUserId) {
        body["openUserId"] = this.LoginModel.openUserId;
      }
      this._http.Post(url, body).subscribe(data => {
        if (data["code"] == 200) {
          this.init.GC(); // 清除缓存，工作台和路由复用
          // this.Jwt.setlocaToken("token", data["data"]["jwt"]); //添加新的token
          this.jwt.setToKen("token", data["data"]["jwt"]); //添加新的token
          this.jwt.removeItem("TabMenu"); //添加新的工作台
          this.jwt.setToKen("systemId", data["data"]["systemId"]);
          //是否强制修改初始密码
          if (data["data"]["isDefaultPwd"]) {
            this.jwt.setToKen("isDefaultPwd", data["data"]["isDefaultPwd"]);
          }

          this.swMenus.location('login');
          //密码过期提醒
          if (data["data"]["expire"]) {
            this.box.danger(data["data"]["expire"]);
          }
        } else {
          this.box.danger(data["msg"]);
        }
      })
    }
  }

  countdown = 0; // 倒计时秒数
  timer: any;
  // 开始倒计时
  startCountdown(seconds: number = 60) {
    if (this.countdown > 0) return;

    this.countdown = seconds;
    this.timer = setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        this.clearTimer();
      }
    }, 1000);
  }

  // 清除定时器
  private clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  onSubmit({ value, valid }, event: Event) {
    this.msg = "";
    //包含大小写字母、数字和特殊字符，至少8位
    // let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[1-9])(?=.*[\W]).{8,}$/
    // if(!reg.test(value.loginPassword)){
    //   this.msg = '密码在8位以上、含大小写、数字、特殊字符'
    //   return
    // }
    if (valid) {
      //登陆先打开loading遮罩层
      this.swLoadingmaskService.openLoading()
      let pwd = Md5.hashStr(value.loginPassword);
      //在这要替换掉特殊字符串,不然会出现BUG
      value.loginName = value.loginName.replace('&', '%26');
      if (value.vcode) {
        value.vcode = value.vcode.replace('&', '%26');
      }

      // partnerCode
      if (!environment.multiTenancy) {
        value.systemCode = environment.systemCode
      }

      //二次加密loginPassword
      let pwdvid: any; //二次加密后的密码

      if (value.vid) {
        //AES加密（密钥使用表单验证码vid）
        pwdvid = this.AESEncryptData(pwd, value.vid);

        // console.log("pwd:"+pwd);

        this.paramLogin = {
          loginName: value.loginName,
          // loginPassword: pwd,
          loginPassword: pwdvid,
          systemCode: value.systemCode,
          vcode: value.vcode,
          vid: value.vid,
        }
        if (this.LoginModel.partnerCode) {
          this.paramLogin = {
            loginName: value.loginName,
            // loginPassword: pwd,
            loginPassword: pwdvid,
            systemCode: value.systemCode,
            partnerCode: value.partnerCode,
            vcode: value.vcode,
            vid: value.vid,
          }
        }
        if (this.LoginModel.openUserId) {
          this.paramLogin["openUserId"] = this.LoginModel.openUserId;
        }
        let path = environment.seekerWebAPI + "sw/userLogin";

        //有验证码的情况下：
        //先转换成大写
        // let uperPwd = pwd.toString().toLocaleUpperCase();
        // let uperVid = value.vid.toLocaleUpperCase();
        // pwdvid = Md5.hashStr(uperPwd + uperVid);

        // let path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd + "&systemCode=" + value.systemCode;
        // if (environment.encryptedPassword == true) {
        //   //需要加密         
        //   path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid + "&systemCode=" + value.systemCode;
        // }

        // let parms = {
        //   loginName: value.loginName,
        //   loginPassword: pwd,
        //   systemCode: value.systemCode,
        //   vcode: value.vcode,
        //   vid: value.vid,
        //   partnerCode: null
        // }

        // if (this.LoginModel.partnerCode) {
        //   path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd + "&systemCode=" + value.systemCode + "&partnerCode=" + value.partnerCode
        //   if (environment.encryptedPassword == true) {
        //     //需要加密
        //     path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid + "&systemCode=" + value.systemCode + "&partnerCode=" + value.partnerCode
        //   }
        //   parms.partnerCode = value.partnerCode;
        // }
        // path += "&vcode=" + value.vcode + "&vid=" + value.vid;

        this.entryLogin(path, true)

      } else {
        //无验证码的情况下，先获得验证码再加密：

        this._http.Post(environment.seekerWebAPI + "sw/queryVCode", {}).subscribe(data => {
          if (data["code"] == 200) {
            //AES加密（密钥使用新获取的验证码vid）
            pwdvid = this.AESEncryptData(pwd, data["data"]["vid"]);

            this.paramLogin = {
              loginName: value.loginName,
              // loginPassword: pwd,
              loginPassword: pwdvid,
              systemCode: value.systemCode,
              vid: data["data"]["vid"],
            }
            if (this.LoginModel.partnerCode) {
              this.paramLogin = {
                loginName: value.loginName,
                // loginPassword: pwd,
                loginPassword: pwdvid,
                systemCode: value.systemCode,
                partnerCode: value.partnerCode,
                vid: data["data"]["vid"],
              }
            }
            if (this.LoginModel.openUserId) {
              this.paramLogin["openUserId"] = this.LoginModel.openUserId;
            }
            let path = environment.seekerWebAPI + "sw/userLogin";

            // let uperPwd = pwd.toString().toLocaleUpperCase();
            // let vid = data["data"]["vid"].toString().toLocaleUpperCase();
            // pwdvid = Md5.hashStr(uperPwd + vid);

            // let path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd + "&systemCode=" + value.systemCode;
            // if (environment.encryptedPassword == true) {
            //   path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid + "&systemCode=" + value.systemCode;
            // }

            // let parms = {
            //   loginName: value.loginName,
            //   loginPassword: pwd,
            //   systemCode: value.systemCode,
            //   vcode: value.vcode,
            //   vid: value.vid,
            //   partnerCode: null
            // }

            // if (this.LoginModel.partnerCode) {             
            //   path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwd + "&systemCode=" + value.systemCode + "&partnerCode=" + value.partnerCode

            //   if (environment.encryptedPassword == true) {               
            //     path = environment.seekerWebAPI + "sw/login?loginName=" + value.loginName + "&loginPassword=" + pwdvid + "&systemCode=" + value.systemCode + "&partnerCode=" + value.partnerCode
            //   }
            //   parms.partnerCode = value.partnerCode;
            // }
            // path += "&vid=" + data["data"]["vid"];

            this.entryLogin(path, false)

          }
        })
      }
    }
  }

  //登录接口
  entryLogin(path, isVid) {

    this._http.Post(path, this.paramLogin).subscribe(
      data => {
        if (data["code"] == 200) {
          this.finishLogin(data["data"], isVid);
        } else if (data["msg"]) {
          this.swLoadingmaskService.closeLoading()
          if (isVid) {
            this.getimg();
          }  //重新获取验证码
          this.LoginModel.vcode = ''  //验证码输入框清空
          this.msg = data["msg"];
          this.initSlideVerify()
        }
      }
    )
  }
  location() {
    // this.config.inItConfig();
    // this.inItConfig();
    //如果是多租户,采取获取登录页面系统下拉框列表
    if (this.multiTenancy) {
      this.getSystemData();
    }
    this.initValue();
  }

  //初始值
  initValue() {
    this.loginSystem = environment.projectName;
    this.copyRight = environment.coptyRight;
    this.loginImage = environment.loginBackGround;
    this.projectLogo = environment.projectLogo;
    this.projectLogoWidth = environment.projectLogoWidth;
    this.isVcode = environment.isVcode;
  }

  clickdianji() {
    $.support.transition = true
  }

  getPartner(systemCode) {
    this.partnerData = [];
    this.LoginModel.partnerCode = ''
    let sysetem = this.systemData.find(x => x.systemCode == systemCode);
    this._http.Get(environment.seekerWebAPI + "sw/queryPartnersBySystemId?systemId=" + sysetem.systemId, {}).subscribe(
      data => {
        if (data["code"] == 200) {
          this.partnerData = data["data"]
        }
      }
    )
  }
  //初始化配置文件
  inItConfig() {
    try {
      if (this.config.config) {
        this.loginSystem = this.config.config.find(x => x.configKey == "SYS_PROJECT_NAME").configValue;
        let image = this.config.config.find(x => x.configKey == "SYS_LOGIN_BACKGROUND").configValue;
        // this.loginImage = "url("+image+") no-repeat center/cover;"
        this.copyRight = this.config.config.find(x => x.configKey == "SYS_COPYRIGHT_STATE").configValue;
      } else {
        this.config.configpdated.subscribe(data => {
          this.loginSystem = data.find(x => x.configKey == "SYS_PROJECT_NAME").configValue;
          let image = data.find(x => x.configKey == "SYS_LOGIN_BACKGROUND").configValue;
          // this.loginImage = "url("+image+")  no-repeat center/cover"
          this.copyRight = data.find(x => x.configKey == "SYS_COPYRIGHT_STATE").configValue;
        })
      }
    } catch (e) { }
  }

  getSystemData() {
    //请求数据
    this._http.Post(environment.seekerWebAPI + "sw/querySystems", {}).subscribe(
      data => {
        if (data["code"] == 200) {
          this.systemData = data["data"]
        }

      }
    )
  }


  img: string = "";

  getimg() {
    this._http.Post(environment.seekerWebAPI + "sw/queryVCode", {}).subscribe(data => {
      if (data["code"] == 200) {
        this.img = "data:image/jpeg;base64," + data["data"]["image"];
        this.LoginModel.vid = data["data"]["vid"]
      }
    })
  }

  //输入用户名的时候直接将 ` 全部替换成空字符串,否则会直接报错400 Bad Request
  enterName(event) {
    if (event.key == '`') {
      this.LoginModel.loginName = event.target.value.replace(/`/g, '')
    }
  }

  //切换语言触发
  // changeEnter(event){
  //   this.defualtlanguage=event.target.value;
  //   this.translateService.use(event.target.value);
  // }

  //切换语言
  selectLanguage(language) {
    this.defualtlanguage = language.id;
    this.translateService.use(language.id);
    this.initSlideVerify()
  }
  //匹配选中的语言
  getLanguageText() {
    let lan = this.languages.filter(item => item.id == this.defualtlanguage)
    if (lan.length > 0) {
      return lan[0].text
    }

  }

  /**
   * 登陆方式切换点击
   * @param
   */
  loginType = 'password'
  loginTypeChange() {
    if (this.loginType === 'password') {
      this.loginType = 'qrcode';
      this.initQRcode();
    } else {
      this.loginType = 'password';
      this.websocketService.close();
    }
  }

  /**
   * 打开ws，获取到二维码的随机数，生成二维码
   */
  qrcode = null;
  generatedCode = false;
  initQRcode() {
    this.generatedCode = false;
    // 打开一个websocket，监听回调，然后登陆
    this.websocketService.close();
    const URL = environment.caWebsocketApi + 'qrcode/connect';
    this.websocketService.create(URL).subscribe(msg => {
      console.log('websocket:', msg)
      if (this.generatedCode) { // 已经生成过二维码，此处接收的是token
        const data = JSON.parse(msg.data);
        const token = data.token;
        const systemId = data.systemId;

        this.websocketService.close();
        this.init.GC(); // 清除缓存，工作台和路由复用
        this.jwt.setToKen("CALogin", '1'); //CA登陆，用于退出登陆不调退出登陆接口
        this.jwt.setToKen("language", this.defualtlanguage); //登录成功后将当前语言设置存进缓存
        this.jwt.setToKen("token", token); //添加新的token
        this.jwt.removeItem("TabMenu"); //添加新的工作台
        this.jwt.setToKen("systemId", systemId);
        this.swMenus.location('login');
      } else { // 未生成过二维码
        const code = msg.data;
        if (code) {
          if (!this.qrcode) {
            this.qrcode = new QRCode(document.getElementById("qrcode"), {
              text: code,
              width: 200,
              height: 200
            });
          } else {
            this.qrcode.makeCode(code);
          }
          this.generatedCode = true;
        }
      }
    });
  }

  openCopyright() {
    window.open('https://beian.miit.gov.cn/#/Integrated/index');
  }
}


